import type { ThemeIconKey } from 'lib/themeIcons';
import themeIconStyles from './ThemeIcon.module.css';

export type IconPathOptions = {
  active?: boolean;
  accent?: boolean;
};

type ThemeIconStyles = typeof themeIconStyles;

export function resolveThemeIconKey(
  icon: ThemeIconKey,
  options?: IconPathOptions
): ThemeIconKey {
  const { active = false, accent = false } = options ?? {};
  if (icon === 'star' || icon === 'star-inactive' || icon === 'star-white') {
    return active ? 'star' : 'star-inactive';
  }
  if (icon === 'checkmark' || icon === 'checkmark-blue') {
    return active ? 'checkmark-blue' : 'checkmark';
  }
  if (
    icon === 'check-lg' ||
    icon === 'check-lg-red' ||
    icon === 'check-lg-white'
  ) {
    if (accent) return 'check-lg-red';
    return icon === 'check-lg-white' ? 'check-lg-white' : 'check-lg';
  }
  return icon;
}

export type ThemeIconVariant = 'grid' | 'footer' | 'inline' | 'desktop';
export type ThemeIconTone = 'chrome' | 'content';

/** Inline icons sit on light cards/lists; grid/footer/desktop sit on dark chrome. */
export function defaultThemeIconTone(variant: ThemeIconVariant): ThemeIconTone {
  return variant === 'inline' ? 'content' : 'chrome';
}

export function themeIconClassName(
  variant: ThemeIconVariant,
  styles: ThemeIconStyles
): string {
  switch (variant) {
    case 'grid':
      return styles.iconGrid;
    case 'footer':
      return styles.iconFooter;
    case 'desktop':
      return styles.iconDesktop;
    default:
      return styles.iconInline;
  }
}

export type { ThemeIconStyles };
